/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import {
  AuthClientHeaderInput,
  AuthClientHeaderInput$Outbound,
  AuthClientHeaderInput$outboundSchema,
} from "./authclientheaderinput.js";

export type SetAuthClientHeadersRequestBody = {
  /**
   * Every header the client should send.
   */
  headers: Array<AuthClientHeaderInput>;
  /**
   * The auth client id.
   */
  id: string;
};

/** @internal */
export type SetAuthClientHeadersRequestBody$Outbound = {
  headers: Array<AuthClientHeaderInput$Outbound>;
  id: string;
};

/** @internal */
export const SetAuthClientHeadersRequestBody$outboundSchema: z.ZodMiniType<
  SetAuthClientHeadersRequestBody$Outbound,
  SetAuthClientHeadersRequestBody
> = z.object({
  headers: z.array(AuthClientHeaderInput$outboundSchema),
  id: z.string(),
});

export function setAuthClientHeadersRequestBodyToJSON(
  setAuthClientHeadersRequestBody: SetAuthClientHeadersRequestBody,
): string {
  return JSON.stringify(
    SetAuthClientHeadersRequestBody$outboundSchema.parse(
      setAuthClientHeadersRequestBody,
    ),
  );
}
